/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


// Product Reviews Forms

define('modules/Reviews/ProductReviews.Forms',[], function () {
    'use strict';

    // Forms definitions
    var forms = {
        'WriteReview': {
            Fields: [
                {
                    "Name": 'Rate It',
                    "Field": '#write-review-rating',
                    "Param": 'rating',
                    "Type": 'Rating'
                },
                {
                    "Name": 'Your Name',
                    "Field": '#writeAuthor',
                    "Param": 'writeAuthor',
                    "Type": 'Text'
                },
                {
                    "Name": 'Headline or Summary',
                    "Field": '#writeTitle',
                    "Param": 'writeTitle',
                    "Type": 'Text'
                },
                {
                    "Name": 'Would you recommend this product?',
                    "Field": '#review-product-recommend',
                    "Type": 'Radiolist'
                },
                {
                    "Name": 'Write Your Review',
                    "Field": '#reviewWrite',
                    "Param": 'reviewWrite',
                    "Type": 'Textarea'
                }
            ],
            Validate: true
        }
    };

    return forms;
});
